/**
 * Runtime environment helper.
 *
 * At build time process.env.REACT_APP_* values are baked into the bundle.
 * When running in a Docker container on AWS the actual values live in
 * window.__ENV__, which is written by scripts/env.sh on container startup
 * (before nginx serves the app).
 *
 * Priority: window.__ENV__ (runtime) → process.env (build-time fallback)
 */
const getEnv = (key) => {
    if (window.__ENV__ && window.__ENV__[key]) {
        return window.__ENV__[key];
    }
    return process.env[key];
};

export const OFFERWALL_API      = getEnv('REACT_APP_OFFERWALL_API');
export const CLOUDFRONT         = getEnv('REACT_APP_CLOUDFRONT');
export const RECAPTCHA_KEY      = getEnv('REACT_APP_RECAPTCHA_KEY');
export const ENV                = getEnv('REACT_APP_ENV');
export const ENROLL_REDIRECT_URL = getEnv('REACT_APP_ENROLL_REDIRECT_URL');
